<template>
    <v-list-item
        :class="['application', 'application-' + application.id]"
        @click="openApplication(application)"
    >
        <v-list-item-avatar
          :class="itemIconClass(application.icon || '')"
          :color="application.icon ? '' :bg_colour(application.name)"
            >
            <v-img :src="application.icon" v-if="application.icon"></v-img>
            <span v-if="!application.icon" class="white--text">{{ application.icon_letters }}</span>
        </v-list-item-avatar>

        <v-list-item-content>
            <v-list-item-title v-html="application.name"></v-list-item-title>
            <!--suppress JSValidateTypes -->
            <span class="description caption">{{ application.description }}</span>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
    import Application from "../models/application";

    export default {
        name: "Application",
        props: {
            application: Application
        },
        methods: {
            itemIconClass(icon) {
                return icon.toLowerCase().indexOf('.flat.') === -1
                    ? ''
                    : 'flat-icon';
            },
            openApplication(application) {
                if (application.hasUrl()) {
                    window.open(application.url, '_self');
                }
            },
            bg_colour(str) {
                if (typeof str == 'undefined') {
                    return 'gray'
                }

                let hash = 0;
                let i;
                for (i = 0; i < str.length; i++) {
                    hash = str.charCodeAt(i) + ((hash << 5) - hash);
                }
                var colour = '#';
                for (i = 0; i < 3; i++) {
                    var value = (hash >> (i * 8)) & 0xFF;
                    colour += ('00' + value.toString(16)).substr(-2);
                }
                return colour;
            }
        }
    }
</script>

<style scoped>
    .description {
        color: #aaa;
        line-height: 100%;
    }

    .flat-icon {
        border-radius: 3px;
    }
</style>
